module.exports = "PROJECTS"


//////////////////
// WEBPACK FOOTER
// C:/Users/phildp/ahs/gdm/code/madebygdm/src/app/posts/posts.component.html
// module id = ../../../../../src/app/posts/posts.component.html
// module chunks = main